import { isEmpty } from 'lodash'

const getTitlePrice = agenda => {
  if (isEmpty(agenda.price_start)) {
    return 'Até R$ ' + agenda.price_end
  }

  if (isEmpty(agenda.price_end)) {
    return 'A parti de R$ ' + agenda.price_start
  }

  return 'De R$ ' + agenda.price_start + ' a R$ ' + agenda.price_end
}

export default (searchedBy, filters, agenda) => {
  if ((agenda.price_start !== '' && agenda.price_start !== null && agenda.price_start !== 0) || (agenda.price_end !== '' && agenda.price_end !== null && agenda.price_end !== 0)) {
    filters['price_start'] = agenda.price_start
    filters['price_end'] = agenda.price_end
    searchedBy.push(getTitlePrice(agenda))
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/filters/filterByPrice.js